'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { COUNTRY_CODE_MX, COUNTRY_CODE_US, CountryCode } from '@sola/schema/dotcom/shared/geo.ts';
import { usePostalMask } from '../../utils/masks.ts';
import { usePostalPattern } from '../../utils/patterns.ts';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';
export type PostalCodeFieldProps = InputFieldProps & {
  countryCode?: CountryCode;
  shouldValidate?: boolean;
};
export const PostalCodeField: React.FC<PostalCodeFieldProps> = t0 => {
  const $ = _c(25);
  let fieldProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      countryCode: t1,
      shouldValidate: t2,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
    $[2] = t1;
    $[3] = t2;
  } else {
    fieldProps = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const countryCode = t1 === undefined ? COUNTRY_CODE_US : t1;
  const shouldValidate = t2 === undefined ? true : t2;
  const {
    mask,
    loadMask
  } = usePostalMask(countryCode);
  const {
    pattern,
    loadPattern
  } = usePostalPattern(countryCode);
  const isUSorMX = countryCode === COUNTRY_CODE_US || countryCode === COUNTRY_CODE_MX;
  const {
    name
  } = fieldProps;
  const formContext = useFormContext();
  let t3;
  if ($[4] !== formContext || $[5] !== name) {
    t3 = () => {
      if (name) {
        formContext.clearErrors(name);
      }
    };
    $[4] = formContext;
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== countryCode) {
    t4 = [countryCode];
    $[7] = countryCode;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  const t5 = isUSorMX ? "numeric" : "text";
  const t6 = shouldValidate && isUSorMX;
  let t7;
  if ($[9] !== loadMask || $[10] !== loadPattern || $[11] !== shouldValidate) {
    t7 = () => {
      loadMask();
      if (shouldValidate) {
        loadPattern();
      }
    };
    $[9] = loadMask;
    $[10] = loadPattern;
    $[11] = shouldValidate;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== mask) {
    t8 = !!mask && {
      maskOptions: mask.options
    };
    $[13] = mask;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== pattern || $[16] !== shouldValidate) {
    t9 = shouldValidate && pattern ? {
      ...pattern
    } : undefined;
    $[15] = pattern;
    $[16] = shouldValidate;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== fieldProps || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <InputField inputMode={t5} required={t6} onVisible={t7} {...t8} pattern={t9} {...fieldProps} />;
    $[18] = fieldProps;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};